import type {
  Logic,
  LOGIC_ACTION
} from '@epilot/journey-logic-commons/src/types/next'

import type { LogicEvent, LogicPriority, RuntimeContext } from './types'

export abstract class Executor {
  public readonly name: LOGIC_ACTION

  constructor(action: LOGIC_ACTION) {
    this.name = action
  }

  abstract priority(logic: Logic): LogicPriority

  abstract event(logic: Logic, context?: RuntimeContext): LogicEvent | undefined
}
